import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';

import { useThirdPartyTags } from '../hooks/useSiteConfig';
import { Helpers } from '../core/src/helpers';
import { useDYAPI, getContext } from '../hooks/useDynamicYieldRecs';

//depricated. Cookie set in akamai
const setITPCookie = () => {
    const cookieID = '_dyid';
    const serverCookieID = '_dyid_server';
    const dyIDCookie = Helpers.getCookie(cookieID);
    const dyIDServer = Helpers.getCookie(serverCookieID);
    if (dyIDCookie && !dyIDServer) {
        /* if this is a returning user and the DYID cookie exists */
        Helpers.setCookie(serverCookieID, dyIDCookie, 365); /* expire in 1 year */
    }
};

export default ({ slugInfo, lang = 'en_US' }) => {
    const { type, data } = getContext(slugInfo);
    const { personalizationConsentString = '2:1,4:1' } = useThirdPartyTags(['personalizationConsentString']);

    return (
        <Helmet>
            <script type="text/javascript">
                {`
                    try{
                        window.DY = window.DY || { };
                        DY.recommendationContext = {type: "${type}"${
                            data && data.length > 0 ? `,data: ${JSON.stringify(data)}` : ''
                        },lng: "${lang}"};
                        DY.userActiveConsent = { accepted: window.localStorage.getItem('userActiveConsent') || false }
                        const setOptIn = function(val, attempt = 0, maxAttempts = 50) {
                            if (typeof window === 'undefined') return;

                            if (window.DYO !== undefined) {
                                try {
                                    DY.userActiveConsent = { accepted: val };
                                    DYO.ActiveConsent.updateConsentAcceptedStatus(val);
                                    window.localStorage.setItem('userActiveConsent', val);

                                    // workaround for DY not updating based on userActiveConsent
                                    if (val) {
                                        const { data, ...rest } = DY.recommendationContext;
                                        DY.recommendationContext = {
                                            ...rest,
                                            data: (data || []).concat(["after_consent"])
                                        };
                                    }
                                } catch (e) {
                                    console.log('Error setting DY consent', e);
                                }
                            } else if (attempt < maxAttempts) {
                                setTimeout(() => setOptIn(val, attempt + 1, maxAttempts), 100);
                            } else {
                                console.warn('DYO not available after max attempts');
                            }
                        };
                        //check for opt in
                        dataLayer.push({
                            event:'pb.onOptInGroups',
                            groups: '${personalizationConsentString}', 
                            callback: function(){setOptIn(true)} 
                          })
                        //check for opt out
                        dataLayer.push({
                            event:'pb.onOptInGroups',
                            groups: '${personalizationConsentString.replace(/\:1/gi, ':0')}', 
                            callback: function(){setOptIn(false)} 
                          })
                    }catch(e){
                        console.log('Error setting DY consent',e)
                    }
                `}
            </script>
        </Helmet>
    );
};

export const DynamicYieldTrackingContainer = ({ children, ContainerComponent = 'div', ...rest }) => {
    const containerRef = useRef(null);
    const dyClient = useDYAPI();

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleClick = e => {
            try {
                const dyElement = e.target.closest('[data-dy-decision-id]');
                if (dyElement && container.contains(dyElement)) {
                    const { dySlotId, dyDecisionId: decisionId } = dyElement.dataset;
                    if (dySlotId) {
                        dyClient.engagment([{ type: 'SLOT_CLICK', slotId: dySlotId }]);
                    } else {
                        dyClient.engagment([{ type: 'CLICK', decisionId }]);
                    }
                }
            } catch (e) {}
        };

        container.addEventListener('click', handleClick);

        return () => {
            container.removeEventListener('click', handleClick);
        };
    }, []);

    return (
        <ContainerComponent ref={containerRef} {...rest}>
            {children}
        </ContainerComponent>
    );
};
